import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "./wrapper";
import {
	simulateTyping,
	clearTyping,
	injectDemoPresentation,
	streamMockAiResponse,
	focusChatInput,
} from "./helpers";
import { goToPage } from "../../../editor/events";

const aiDemo = (hostId: string): StepType[] => [
	{
		selector: ".chat-codemirror",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.demoTyping}
			/>
		),
		position: "right",
		action: () => {
			focusChatInput();
			simulateTyping(text.tourSteps.demoPrompt);
		},
	},
	{
		selector: ".chat-codemirror",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.demoAiPlans}
			/>
		),
		position: "right",
		action: () => {
			clearTyping();
			streamMockAiResponse(text.tourSteps.demoPrompt, text.tourSteps.demoMockRationale);
		},
	},
	{
		selector: ".cm-create-prompt",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.demoCreateButton}
			/>
		),
		position: "right",
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.demoPresentationAppears}
			/>
		),
		position: "left",
		action: () => {
			injectDemoPresentation(hostId);
			goToPage(hostId, "QP", 1);
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.demoNavigate}
			/>
		),
		position: "left",
		action: () => {
			goToPage(hostId, "QP", 2);
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.demoSlideDesign}
			/>
		),
		position: "left",
		action: () => {
			goToPage(hostId, "QP", 3);
		},
	},
	{
		selector: ".chat-codemirror",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.demoContinueConversation}
						<br />
						<br />
						{text.tourSteps.demoExampleHydro}
						<br />
						{text.tourSteps.demoExampleRewrite}
						<br />
						{text.tourSteps.demoExampleCaptions}
					</span>
				)}
			/>
		),
		position: "right",
		action: () => {
			goToPage(hostId, "QP", 1);
		},
	},
];

export default aiDemo;
